import React from 'react';
import { StyleSheet } from 'react-native';
// TODO: JT-124813 importing FlatList from react-native-gesture-handler for now until
// we figure out why its not working with the react-native import
import { ScrollView } from 'react-native-gesture-handler';
import Button, { ButtonProps } from 'shared/components/vxl/Button/Button';
import theme from 'shared/styles/theme';

export type ScrollingButtonItem = {
  id: string | number;
  props: Omit<ButtonProps, 'width' | 'size' | 'type'>;
};

export interface ScrollingButtonGroupProps {
  buttons: ScrollingButtonItem[];
}

const ScrollingButtonGroup = ({ buttons }: ScrollingButtonGroupProps) => {
  if (!buttons.length) {
    return null;
  }

  return (
    <ScrollView
      contentContainerStyle={styles.scrollViewContentContainer}
      horizontal
      showsHorizontalScrollIndicator={false}
    >
      {buttons.map(({ id, props }) => {
        return (
          <Button
            key={id.toString()}
            size="LARGE"
            type="PRIMARY"
            width="HUG"
            {...props}
          />
        );
      })}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scrollViewContentContainer: {
    flexGrow: 1,
    gap: theme.spacing.s,
    paddingHorizontal: theme.spacing.m,
  },
});

export default ScrollingButtonGroup;
